(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

// 创城相关
export var JcbName = process.env.REACT_APP_TYPE === 'city' ? '实地检查-清研文明城市（区）创建智慧管理系统' : process.env.REACT_APP_TYPE === 'ny' ? '实地测评-农村人居环境监测智慧管理系统' : '调研工厂-明察暗访';
export var homeCity = 'https://www.wenming.city/';
export var dyDomainCity = process.env.REACT_APP_JCB_ENV === 'dev' ? 'http://test.base.wenming.city' : 'https://console.wenming.city';

export var wjDomainCity = process.env.REACT_APP_JCB_ENV === 'dev' ? 'http://test.wj.wenming.city' : 'https://wj.wenming.city';
export var sbDomainCity = process.env.REACT_APP_JCB_ENV === 'dev' ? 'http://test.cailiao.cac7d791610d6444899e9153f4f3a74d7.cn-beijing.alicontainer.com' : 'http://sb.wenming.city';

// 农业项目相关
export var homeNy = 'http://ncrjhj.survey.work/';
export var dyDomainNy = 'http://console.ncrjhj.survey.work';
export var wjDomainNy = 'http://wj.ncrjhj.survey.work';
export var pxDomainNy = 'http://px.ncrjhj.survey.work';
export var jcbDomainNy = 'http://jc.ncrjhj.survey.work';

// 项目id相关(用于针对定制的处理)
export var projectIds = {
  shangzhang: process.env.REACT_APP_JCB_ENV === 'dev' ? ['1280', '1285', '1299', '838', '1292', '1354'] : ['1044', '1103', '1158', '1187', '1104', '1530']
};

// 企业id 判断是否定制导航
export var customNavCompanyIds = [{
  id: process.env.REACT_APP_JCB_ENV === 'dev' ? '20054' : '1450847',
  name: '垃圾分类督查考核智慧管理平台',
  sysMenus: [{ id: 'home', name: '首页', serviceType: 0, link: '' }, { id: 'sb', name: '材料申报', serviceType: 13, link: '' }, { id: 'jcb', name: '实地检查', serviceType: 2, link: '' }, { id: 'survey', name: '问卷调查', serviceType: 1, link: '' }, {
    id: 'show',
    name: '成果展示',
    serviceType: 15,
    open: true,
    link: 'https://datav.aliyuncs.com/share/f61f2ab6ae848e850d5466e24828b81b'
  }, {
    id: 'pxb',
    name: '培训学习',
    serviceType: 4,
    link: ''
  }, { id: 'manage', name: '账号管理', serviceType: 0, link: '' }]
}, {
  id: process.env.REACT_APP_JCB_ENV === 'dev' ? '20060' : '1450849',
  name: '拉萨',
  sysMenus: [{ id: 'home', name: '首页', serviceType: 0, link: '' }, { id: 'sb', name: '材料申报', serviceType: 13, link: '' }, { id: 'jcb', name: '实地检查', serviceType: 2, link: '' }, { id: 'survey', name: '问卷调查', serviceType: 1, link: '' },
  // {
  //   id: 'show',
  //   name: '数据大屏',
  //   serviceType: 20,
  //   open: true,
  //   link: '',
  // },
  {
    id: 'pxb',
    name: '调研培训',
    serviceType: 4,
    link: ''
  }, { id: 'manage', name: '账号管理', serviceType: 0, link: '' }]
}];
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(JcbName, 'JcbName', 'src/utils/constant.js');
  reactHotLoader.register(homeCity, 'homeCity', 'src/utils/constant.js');
  reactHotLoader.register(dyDomainCity, 'dyDomainCity', 'src/utils/constant.js');
  reactHotLoader.register(wjDomainCity, 'wjDomainCity', 'src/utils/constant.js');
  reactHotLoader.register(sbDomainCity, 'sbDomainCity', 'src/utils/constant.js');
  reactHotLoader.register(homeNy, 'homeNy', 'src/utils/constant.js');
  reactHotLoader.register(dyDomainNy, 'dyDomainNy', 'src/utils/constant.js');
  reactHotLoader.register(wjDomainNy, 'wjDomainNy', 'src/utils/constant.js');
  reactHotLoader.register(pxDomainNy, 'pxDomainNy', 'src/utils/constant.js');
  reactHotLoader.register(jcbDomainNy, 'jcbDomainNy', 'src/utils/constant.js');
  reactHotLoader.register(projectIds, 'projectIds', 'src/utils/constant.js');
  reactHotLoader.register(customNavCompanyIds, 'customNavCompanyIds', 'src/utils/constant.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();